import { useState } from "react";
import { TotalCountBadge } from "src/components/TotalCountBadge";
import { SecondaryButton } from "src/components/Buttons";
import {
  SectionContainer,
  SectionHeader,
  SectionTitle,
  SectionList,
} from "./ResourcesSection.styles";
import { FilePDFIcon } from "src/assets/icons";
import styled from "@emotion/styled";
import { ERROR_COLOR } from "src/constants/colors";

const PDFIconWrapper = styled.div`
  position: absolute;
  right: -26px;
  top: 10px;
  color: ${ERROR_COLOR};
  opacity: 0;
  transition: opacity 0.2s ease;
`;

const SectionItemWrapper = styled.div`
  position: relative;

  &:hover .pdf-icon {
    opacity: 1;
  }
`;

interface SectionItem {
  title: string;
  icon: React.ComponentType;
  link: string;
}

interface ResourcesSectionProps {
  title: string;
  sectionData: SectionItem[];
}

export default ({ title, sectionData }: ResourcesSectionProps) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async (sectionItem: SectionItem) => {
    setLoading(true);

    try {
      const link = document.createElement("a");
      link.href = sectionItem.link;
      link.download = sectionItem.title;
      link.target = "_blank";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      await new Promise((resolve) => setTimeout(resolve, 1500));
    } finally {
      setLoading(false);
    }
  };

  return (
    <SectionContainer>
      <SectionHeader>
        <SectionTitle>{title}</SectionTitle>
        <TotalCountBadge>{sectionData.length}</TotalCountBadge>
      </SectionHeader>
      <SectionList>
        {sectionData.map((sectionItem) => {
          const Icon = sectionItem.icon;
          return (
            <SectionItemWrapper key={sectionItem.title}>
              <SecondaryButton
                loading={loading}
                onClick={() => {
                  void handleDownload(sectionItem);
                }}
              >
                <Icon />
                {sectionItem.title}
              </SecondaryButton>
              <PDFIconWrapper className="pdf-icon">
                <FilePDFIcon />
              </PDFIconWrapper>
            </SectionItemWrapper>
          );
        })}
      </SectionList>
    </SectionContainer>
  );
};
